import React from 'react'

function Other() {
  return (
    <div className='others_div'>
      <div className='big_conts'>
        <div>
        <div><h1 className='AN'>Alumni Network</h1></div>
        <div><p className='coming_soon'>Coming Soon...</p></div>
        </div>
      </div>
      <div className='big_conts'>
      <div>
        <div><h1 className='AN'>Mentorship</h1></div>
        <div><p className='coming_soon'>Coming Soon...</p></div>
        </div>
      </div>
      
    </div>
  )
}

export default Other
